import $ from "jquery";
import { parseFormData, XHRInterceptor } from "../utils/utility";

const reservationForm = () => {
  const el = {
    main: ".sidebar-booking-module-body",
  };
  const init = () => {
    if (!$(el.main).length) return;
    handlerXhrInterceptor();
  };

  const handlerXhrInterceptor = () => {
    let isReservationXhr = false;
    let isAvailabilityXhr = false;

    XHRInterceptor.enable({
      onSend: ({ data, abort }) => {
        const parsedData = parseFormData(data);

        if (parsedData.action == "check_booking_availability_on_date_change") {
          $(".spinner").show();
          const isValid = handlerValidationChangeDate();
          if (!isValid) {
            $(".homey-icon-loading-half").hide();
            abort();
          } else {
            isAvailabilityXhr = true;
          }
        } else if (parsedData.action == "homey_add_reservation") {
          $(".spinner").show();
          const isValid = handlerValidationForm();

          if (!isValid) {
            $(".homey-icon-loading-half").hide();
            abort();
          } else {
            isReservationXhr = true;
          }
        }
      },
      onComplete: ({ response }) => {
        const parserResponse = JSON.parse(response);

        if (isAvailabilityXhr) {
          isAvailabilityXhr = false;
        } else if (isReservationXhr && parserResponse.success) {
          // Reset input values
          $('input[name="child_guest"]').val("0");
          $('input[name="adult_guest"]').val("0");
          $("#search-guests").val("");
          $(".quantity-calculator.homey_adult").text("0");
          $(".quantity-calculator.homey_child").text("0");
          $("li.selected").removeClass("selected");
          $(".homey-icon-loading-half").hide();
          isReservationXhr = false;
        }
      },
    });
  };

  const handlerValidationForm = () => {
    let isValid = true;

    const $messageBox = $(".homey_notification");

    const searchGuests = $("#search-guests");
    const checkInInput = $("#search-date-range-arrive");
    const checkOutInput = $("#search-date-range-depart");

    if (!checkOutInput.val() && checkInInput.val() && searchGuests.val()) {
      setTimeout(() => {
        $(".notify ").remove();
        $messageBox.prepend(
          `<div class='notify text-danger text-center btn-danger-outlined btn btn-full-width'>
            Please select the check-out date
          </div>`
        );
        $(".spinner").hide();
      }, 300);

      isValid = false;
    }

    if (checkInInput.val() && checkOutInput.val()) {
      // Convert dd-mm-yyyy to yyyy-mm-dd
      const toISO = (dateStr) => dateStr.split('-').reverse().join('-');
      
      const checkInDate = new Date(toISO(checkInInput.val()));
      const checkOutDate = new Date(toISO(checkOutInput.val()));

      if (checkOutDate <= checkInDate) {
        setTimeout(() => {
          $(".notify ").remove();
          $messageBox.prepend(
            `<div class='notify text-danger text-center btn-danger-outlined btn btn-full-width'>
              The check-out date must be greater than the check-in date
            </div>`
          );
          $(".spinner").hide();
        }, 300);

        isValid = false;
      }
    }

    return isValid;
  };

  const handlerValidationChangeDate = () => {
    let isValid = true;
    const $messageBox = $(".homey_notification");

    const searchGuests = $("#search-guests");
    const checkInInput = $("#search-date-range-arrive");
    const checkOutInput = $("#search-date-range-depart");

    if (!checkInInput.val() && !checkOutInput.val() && !searchGuests.val()) {
      setTimeout(() => {
        $(".notify ").remove();
        $messageBox.prepend(
          `<div class='notify text-danger text-center btn-danger-outlined btn btn-full-width'>
            Please fill all the fields
          </div>`
        );
        $(".spinner").hide();
      }, 300);

      isValid = false;
    } else if (!checkInInput.val()) {
      setTimeout(() => {
        $(".notify ").remove();
        $messageBox.prepend(
          `<div class='notify text-danger text-center btn-danger-outlined btn btn-full-width'>
            Please select the check-in date
          </div>`
        );
        $(".spinner").hide();
      }, 300);

      isValid = false;
    } else if (!checkOutInput.val()) {
      setTimeout(() => {
        $(".notify ").remove();
        $messageBox.prepend(
          `<div class='notify text-danger text-center btn-danger-outlined btn btn-full-width'>
            Please select the check-out date
          </div>`
        );
        $(".spinner").hide();
      }, 300);

      isValid = false;
    } else if (checkInInput.val() && checkOutInput.val()) {
      // Convert dd-mm-yyyy to yyyy-mm-dd
      const toISO = (dateStr) => dateStr.split('-').reverse().join('-');
      
      const checkInDate = new Date(toISO(checkInInput.val()));
      const checkOutDate = new Date(toISO(checkOutInput.val()));
      
      if (checkOutDate <= checkInDate) {
        setTimeout(() => {
          $(".notify ").remove();
          $messageBox.prepend(
            `<div class='notify text-danger text-center btn-danger-outlined btn btn-full-width'>
              The check-out date must be greater than the check-in date
            </div>`
          );
          $(".spinner").hide();
        }, 300);

        isValid = false;
      } else if (!searchGuests.val()) {
        setTimeout(() => {
          $(".notify ").remove();
          $messageBox.prepend(
            `<div class='notify text-danger text-center btn-danger-outlined btn btn-full-width'>
              Please choose the number of guests
            </div>`
          );
          $(".spinner").hide();
        }, 300);

        isValid = false;
      }
    }

    return isValid;
  };

  init();
};

try {
  reservationForm();
} catch (e) {
  console.error("MI Gallery : ", e);
}
